import React, { useEffect, useState } from "react";
import TableModalHeader from "../../UtilitiesComponent/TableModalHeader";
import {
  setFrom,
  setTo,
} from "../../../redux-toolkit/slices/dashboard.revised.titled";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { FetchSubmitedVideos } from "../../../api/functions/submited.videos.api";
import { useQuery } from "react-query";
import ApiLoader from "../../Loaders/ApiLoader";
import EmptyTable from "../../EmptyTable/EmptyTable";
import NoResultTwo from "../../NoResult/NoResultTwo";
import DashboardModalFilterWrapper from "../../UtilitiesComponent/DashboardModalFilterWrapper";
import Filter from "../../Filter/Filter";
import DashboardVideosFilterModal from "../../FilterModal/DashboardVideosFilterModal ";
import DashboardModalVideosTable from "./Fragments/DashboardModalVideosTable";
import DashboardModalWrapper from "../ModalTableWrappers/DashboardModalWrapper";
import SubmittedPendingTable from "../../AllTable/SubmittedPageVideos/SubmittedPendingTable";
import { Box } from "@mui/system";
import styles from "../../../styles/pages/home.module.scss";
import assest from "../../../json/assest";
import DashboardTitleVideoTable from "../../AllTable/DashboardTables/DashboardTitleVideoTable";
import DashboardRevisionVideoTable from "../../AllTable/DashboardTables/DashboardRevisionVideoTable";

const DashboardTitledRevisedModal = (props) => {
  const { enable, headerTitle } = props;
  const [fetchTrigger, setFetchTrigger] = useState(Date.now());
  const [page, setPage] = useState(1);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [search, setSearch] = useState("");

  const dispatch = useAppDispatch();
  // console.warn('enable', enable)

  const { from, to } = useAppSelector((s) => s.dashboardRevisedTitled);

  const {
    error,
    data,
    isLoading,
    isRefetching,
    refetch: refetchAgain,
  } = useQuery(
    ["titled_rev"],
    async () =>
      FetchSubmitedVideos({
        revised: "yes",
        page: search ? null : page,
        search,
        from,
        to,
      }),
    { enabled: enable }
  );

  // console.warn("enable", enable);

  const handlePageChange = (p) => {
    setPage(p);
  };

  useEffect(() => {
    if (enable) {
      refetchAgain();
    }
  }, [page, fetchTrigger]);

  const filterRefetch = () => {
    refetchAgain();
    // setOpenFilterModal(false);
  };

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };

  const filtersReset = () => {
    setSearch("");
    handleTriggreFetch();
  };
  useEffect(() => {
    if (!enable || !search) return;

    const debounceTimeout = setTimeout(() => {
      refetchAgain();
    }, 1000);

    return () => {
      clearTimeout(debounceTimeout);
    };
  }, [search]);
  const handleInputChange = (event) => {
    let inputValue = event.target.value;
    setSearch(inputValue);
    if (!inputValue) {
      filtersReset();
    }
  };

  return (
    <>
      <DashboardModalWrapper
        {...props}
        modalHeader={
          <Box
            className={`${styles.table_left1} ${styles.table_left_pendings}`}
          >
            <p>
              <img src={assest.ticled_video} width={22} height={22} alt="" />{" "}
              {headerTitle}
            </p>
          </Box>
        }
        filterRow={
          <DashboardModalFilterWrapper
            filterModalProps={{
              // ...tableDataProps,
              openFilterModal,
              setOpenFilterModal,
              handleTriggreFetch,
              data: data?.data,
              // handleClearFilterModal,
              filtersReset,
              filterRefetch,
              handleInputChange,

              states: {
                from,
                to,
                search,
              },
              setStates: {
                setFrom,
                setTo,
              },
            }}
            // hideFilter
            hideLastItem
            isPending
            FilterModalComponent={null}
            filterActive={search ? true : false}
          />
        }
      >
        <ApiLoader loading={isLoading} />
        <DashboardRevisionVideoTable
          datas={data?.data}
          hideFilter
          filterActive={search ? true : false}
          handlePageChange={handlePageChange}
          filterRefetch={filterRefetch}
          handleClearFilterModal={filtersReset}
          filtersReset={filtersReset}
          error={error}
          page={page}
          handleTriggreFetch={handleTriggreFetch}
          loading={isLoading}
          p={{
            openFilterModal,
            setOpenFilterModal,
            handleTriggreFetch,
          }}
        />
      </DashboardModalWrapper>
    </>
  );
};

export default DashboardTitledRevisedModal;
